import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import CardWithLinkEditorial from "components/flexComponents/Content/factory/impl/editorials/CardWithLinkEditorial";

export class SnippetEditorial extends CardWithLinkEditorial {
  /* istanbul ignore next */
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public getEditorialItemClassName = (): string => "all-t-margin-three";
}

export default SnippetEditorial;
